import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import {
  LinkSalesforceAccountWidget,
  SalesforceInspectorItem
} from 'Integrations/index'
import { LinkSalesforceBillingScheduleWidget } from 'Integrations/integrationsConfig/salesforce/InspectorItem/widgets/LinkSalesforceBillingScheduleWidget'
import { usePermissions } from 'lib/rbac'

const useSalesforceInspectorItem = (props: { billingScheduleId: string }) => {
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId: props.billingScheduleId,
    select: data => {
      return {
        customerId: data.billingSchedule.customerId
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    customerId: billingScheduleAggregateQuery.data?.customerId
  }
}

export const BillingScheduleSalesforceInspectorItem = (props: {
  billingScheduleId: string
}) => {
  const { customerId } = useSalesforceInspectorItem(props)
  const { can } = usePermissions()
  const canUpdateIntegrations = can('org.billing:update')

  return (
    <SalesforceInspectorItem>
      <LinkSalesforceAccountWidget
        customerId={customerId}
        disabled={!canUpdateIntegrations}
      />
      <LinkSalesforceBillingScheduleWidget
        disabled={!canUpdateIntegrations}
        billingScheduleId={props.billingScheduleId}
      />
    </SalesforceInspectorItem>
  )
}
